// extracted by mini-css-extract-plugin
export default {"customLink":"Link_customLink__8plV8"};